<template>
  <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
    <rect x="1" y="4" width="14" height="8" rx="2" ry="2"/>
    <line x1="4" y1="8" x2="4" y2="8"/>
    <line x1="6" y1="8" x2="6" y2="8"/>
    <line x1="8" y1="8" x2="8" y2="8"/>
    <line x1="10" y1="8" x2="10" y2="8"/>
    <line x1="12" y1="8" x2="12" y2="8"/>
    <line x1="5" y1="10" x2="11" y2="10"/>
  </svg>
</template>
